"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("./styles");
var _react2 = require("@emotion/react");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const Menu = ({
  lightTheme,
  open,
  children
}) => {
  const theme = (0, _react2.useTheme)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Wrapper, {
    lightTheme: Boolean(lightTheme),
    open: open,
    theme: theme,
    children: children
  });
};
var _default = exports.default = Menu;